(function ($) {
  DJ.addBehavior('enableFormEdit', '.js-enable-form-edit', {
    attach: function () {
      const formContainer = this;
      const modifyButton = formContainer.querySelector('.form-identity__btn');
      const submitBtnContainer = formContainer.querySelector(
        '.form-identity__item--submit'
      );
      const showSubmitBtnClass = 'form-identity__item--submit-show';
      const editableItems = formContainer.querySelectorAll(
        '.form-identity__input--data-editable'
      );

      if (!modifyButton) return false;

      modifyButton.addEventListener('click', function () {
        if (submitBtnContainer) {
          if (submitBtnContainer.classList.contains(showSubmitBtnClass)) {
            submitBtnContainer.classList.remove(showSubmitBtnClass);

            if (editableItems) {
              Array.prototype.slice.call(editableItems).forEach((item) => {
                if (item.tagName === 'INPUT') {
                  item.setAttribute('readonly', true);
                  item.classList.remove('form-identity__input--writable');
                }

                if (item.tagName === 'SELECT') {
                  item.setAttribute('disabled', true);
                  item.classList.remove('form-identity__input--writable');
                }
              });
            }
          } else {
            submitBtnContainer.classList.add(showSubmitBtnClass);

            if (editableItems) {
              Array.prototype.slice.call(editableItems).forEach((item) => {
                if (item.tagName === 'INPUT') {
                  item.removeAttribute('readonly');
                  item.classList.add('form-identity__input--writable');
                }

                if (item.tagName === 'SELECT') {
                  item.removeAttribute('disabled');
                  item.classList.add('form-identity__input--writable');
                }
              });
            }
          }
        }
      });

      return true;
    },
  });
})(jQuery);
